function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0007 25.7663C17.1469 25.7663 18.0762 24.8371 18.0762 23.6908L18.0762 18.7621C18.0762 18.1253 18.5925 17.609 19.2293 17.609L24.158 17.609C25.3043 17.609 26.2335 16.6798 26.2335 15.5335C26.2335 14.3872 25.3043 13.458 24.158 13.458L17.4418 13.458C15.4996 13.458 13.9251 15.0324 13.9251 16.9747C13.9251 19.2134 13.9251 21.4521 13.9251 23.6908C13.9251 24.8371 14.8544 25.7663 16.0007 25.7663Z",
  fill: "#306bf6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7653 10.5326C13.581 10.5326 10.9997 13.114 10.9997 16.2983L10.9997 23.5842C10.9997 24.8042 10.0106 25.7933 8.79059 25.7933C7.57054 25.7933 6.58149 24.8042 6.58149 23.5842L6.58149 15.916C6.58149 10.5027 10.9698 6.11444 16.383 6.11444L24.0512 6.11444C25.2713 6.11444 26.2603 7.10349 26.2603 8.32354C26.2603 9.54359 25.2713 10.5326 24.0512 10.5326L16.7653 10.5326Z",
  fill: "#306bf6"
});

function SvgPipeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeline);
export default __webpack_public_path__ + "static/media/pipeline.f9b3daa9.svg";
export { ForwardRef as ReactComponent };